import { Button, Col, Typography } from "antd";
import { useFormContext } from "react-hook-form";
import { InputPassword, InputText, LoginLayout } from "../../../shared/components";
import { useLogin, FormData } from "../hooks/useLogin";
import { 
  WrapperLoginContainer, 
  LeftPanel, 
  RightPanel, 
  FormContainer 
} from "./styled";

const { Title, Text } = Typography;

export const Login = () => {
  const { isLoading, onLoginUser } = useLogin();
  const { control, handleSubmit: onSubmit } = useFormContext<FormData>();

  return (
    <LoginLayout pageDescription="Login For Users" title="Login">
      <WrapperLoginContainer>
        {/* Panel Izquierdo - Hero */}
        <LeftPanel>
          <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
            <Title
              style={{
                color: "white",
                fontSize: "48px",
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: "24px",
              }}
            >
              Administra Sushi2GO
              <br />
              desde un solo lugar.
            </Title>
            <Text
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "18px",
                lineHeight: 1.6,
              }}
            >
              Gestiona pedidos en tiempo real, actualiza tu menú,
              <br />
              controla inventario y crea promociones exclusivas.
            </Text>
          </div>
        </LeftPanel>

        {/* Panel Derecho - Formulario */}
        <RightPanel>
          <FormContainer>
            {/* Logo */}
            <div style={{ marginBottom: "32px", textAlign: "center" }}>
              <img
                src={"/logo-sushi2gon.png"}
                alt="Sushi2Go"
                style={{
                  width: "180px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Título */}
            <Title
              level={2}
              style={{
                color: "#1a1a1a",
                fontSize: "32px",
                fontWeight: 700,
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              Bienvenido
            </Title>
            <Text
              style={{
                color: "#8c8c8c",
                fontSize: "16px",
                display: "block",
                textAlign: "center",
                marginBottom: "40px",
              }}
            >
              Panel de Administración — Inicia sesión
            </Text>

            {/* Campo Email */}
            <Col
              span={24}
              style={{
                marginBottom: "24px",
              }}
            >
              <Text
                strong
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "#262626",
                  fontSize: "14px",
                }}
              >
                Tu correo
              </Text>
              <InputText
                placeHolder="admin@tu-restaurante.com"
                name="email"
                control={control}
              />
            </Col>

            {/* Campo Contraseña */}
            <Col
              span={24}
              style={{
                marginBottom: "32px",
              }}
            >
              <Text
                strong
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "#262626",
                  fontSize: "14px",
                }}
              >
                Contraseña
              </Text>
              <InputPassword name="password" control={control} />
            </Col>

            {/* Botón de Login */}
            <Button
              type="primary"
              size="large"
              onClick={onSubmit(onLoginUser)}
              loading={isLoading}
              style={{
                width: "100%",
                height: "50px",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: 600,
                background: "linear-gradient(135deg, #E95735 0%, #ff8566 100%)",
                border: "none",
                boxShadow: "0 4px 12px rgba(233, 87, 53, 0.3)",
              }}
            >
              Ingresar al panel
            </Button>

            {/* Texto de ayuda */}
            <Text
              style={{
                display: "block",
                textAlign: "center",
                marginTop: "24px",
                color: "#8c8c8c",
                fontSize: "14px",
              }}
            >
              ¿Olvidaste tu contraseña?{" "}
              <span style={{ color: "#E95735", fontWeight: 500, cursor: "pointer" }}>
                Contacta al administrador
              </span>
            </Text>
          </FormContainer>
        </RightPanel>
      </WrapperLoginContainer>
    </LoginLayout>
  );
};
